import { useState, useEffect } from 'react';
import Icon from '../../../../Icon/Icon';

function RenderPreview({ previewType, previewSrc, previewProperties }) {
    const [fileType, setFileType] = useState(previewType);

    function rotationDeg(rotation) {
        switch (rotation) {
            case 'plus90':
                return 90;
            case 'minus90':
                return -90;
            case 'upsideDown':
                return -180;
            default:
                return 0;
        }
    }

    return (
        <div
            className="w-full h-full max-h-48 max-w-36 justify-center text-center align-middle flex items-center mx-auto"
            style={{
                width: previewProperties.width + 'px',
                height: previewProperties.height + 'px',
                rotate: `${rotationDeg(previewProperties.rotation)}deg`,
                aspectRatio: `${previewProperties.width}/${previewProperties.height}`,
            }}>
            {fileType == 'image' && (
                <img
                    src={previewSrc}
                    className="max-w-full max-h-full object-contain"
                    style={{
                        width: 'auto',
                        height: previewProperties.height + 'px',
                    }}
                />
            )}
            {fileType == 'video' && (
                <video
                    src={previewSrc}
                    controls
                    autoplay
                    muted
                    className="max-h-full max-w-full"
                    style={{
                        width: 'auto',
                        height: previewProperties.height + 'px',
                    }}
                />
            )}
            {fileType == 'dynamic' && (
                <div className="w-full h-full bg-gradient-to-br from-black via-gray-800 to-black flex items-center justify-center flex-col">
                    <Icon
                        name="code"
                        size="2x"
                        className="text-white opacity-90"
                    />
                    <span className="text-white opacity-90 mt-2">
                        Dynamic Creative
                    </span>
                </div>
            )}
        </div>
    );
}

export default RenderPreview;
